/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../controls.module.ts" />
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../../../../components/models/meevo.model.custom.ts"/>


module Meevo.Components.Controls {

    import Dictionary = _.Dictionary;
    import PurchaseOrderStateEnum = Meevo.Model.PurchaseOrderStateEnum;
    import IReportControlCriteria = Meevo.Plugins.Reports.IReportControlCriteria;
    import IReportControlScope = Meevo.Plugins.Reports.IReportControlScope;

    export class Mi100Criteria implements IReportControlCriteria {

        public criteria: Dictionary<any>;

        constructor(private scope: IReportControlScope) {
            this.criteria = {
                StartDate: this.scope.mainModel[this.scope.parameterNames[1]] ? this.scope.mainModel[this.scope.parameterNames[1]] : this.scope.options.parameters[1].value,
                EndDate: this.scope.mainModel[this.scope.parameterNames[2]] ? this.scope.mainModel[this.scope.parameterNames[2]] : this.scope.options.parameters[2].value,
                PurchaseOrderStateEnumList_Tbl: [
                    PurchaseOrderStateEnum.PartiallyReceived,
                    PurchaseOrderStateEnum.ReceivedInFull,
                    PurchaseOrderStateEnum.NotReceived
                ]
            };

            scope.$watch(() => [
                scope.mainModel[this.scope.parameterNames[1]],
                scope.mainModel[this.scope.parameterNames[2]]
            ], _.debounce(this.updateCriteria.bind(this), 200), true);
        }

        private updateCriteria() {
            angular.extend(this.criteria, {
                StartDate: this.scope.mainModel[this.scope.parameterNames[1]] ? this.scope.mainModel[this.scope.parameterNames[1]] : this.scope.options.parameters[1].value,
                EndDate: this.scope.mainModel[this.scope.parameterNames[2]] ? this.scope.mainModel[this.scope.parameterNames[2]] : this.scope.options.parameters[2].value
            });
            this.scope.$apply();
        }
    }

}